<template>
  <nuttrema-layout-default-slide
    :class="{ 'is-index-mode': $route.name === 'diet-schedules' }"
    :layout-slide-mode-key="KEYS.LAYOUT_PROGRAMS_VIEW_SLIDE_MODE">

    <template slot="collapsed-menu-top-brand">
      <nuttrema-brand-image link="professional-home"></nuttrema-brand-image>
    </template>

    <template slot="overflow">

      <page-help
         v-if="show.pageHelp"
         file="program-diet"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>

      <page-program-reports
         v-if="show.pageProgramReports"
        :id="id"
        @close="show.pageProgramReports = false">
      </page-program-reports>

      <page-send-to-participant
         v-if="show.pageSendProgramToParticipant"
        :id="id"
        @close="show.pageSendProgramToParticipant = false">
      </page-send-to-participant>

      <page-make-copy-program
         v-if="show.pageMakeCopyProgram"
        :id="id"
        @close="show.pageMakeCopyProgram = false">
      </page-make-copy-program>

    </template>

    <template slot="collapsed-menu-top">
      <nuttrema-menu-list theme="sidebar-menu" class="in-collapsed">
        <nuttrema-menu-list-item class="if-level-one">
          <a><sidebar-icon-level-zero></sidebar-icon-level-zero></a>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item class="if-level-one">
          <router-link
             tag="a"
            :title="backTo.label"
            :to="backTo.route">
            <nuttrema-iconica-sidebar-link theme="gray" icon="far fa-arrow-left"></nuttrema-iconica-sidebar-link>
          </router-link>
        </nuttrema-menu-list-item>
      </nuttrema-menu-list>
    </template>

    <template slot="collapsed-menu-level-zero">
      <sidebar-menu-level-zero-collapsed
        class="collapsed-menu-level-zero is-collapsed">
      </sidebar-menu-level-zero-collapsed>
    </template>

    <template slot="collapsed-menu-level-one">
      <sidebar-menu-diet-collapsed
         v-if="ProgramDetails.ready"
         class="collapsed-menu-level-one is-collapsed"
        :id="id"
        :dayID="initialDayID"
        :dietDetails="ProgramDetails">
      </sidebar-menu-diet-collapsed>
    </template>

    <template slot="expanded-menu-level-one">
      <sidebar-menu-diet-expanded
         v-if="ProgramDetails.ready"
         class="expanded-menu-level-one is-expanded"
        :id="id"
        :meta="meta"
        :dayID="initialDayID"
        :dietDetails="ProgramDetails">
      </sidebar-menu-diet-expanded>
      <nuttrema-loader
         v-else-if="ProgramDetails.fetching"
        :showText="false">
      </nuttrema-loader>
    </template>

    <nuttrema-menu-list slot="sidebar-collapsed-bottom">
      <nuttrema-menu-list-item>
          <sidebar-link-overlay-usermenu></sidebar-link-overlay-usermenu>
      </nuttrema-menu-list-item>
    </nuttrema-menu-list>

  </nuttrema-layout-default-slide>
</template>

<script>
import { get, isNil, find, first } from 'lodash';

import * as EVENT from 'constants/event';

import { PROGRAMS_KEYS } from 'constants/types';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

import SidebarMenuDietExpanded from 'components/ui/menu/programs/sidebar-menu-diet-expanded';
import SidebarMenuDietCollapsed from 'components/ui/menu/programs/sidebar-menu-diet-collapsed';

import PageProgramReports from 'components/pages/professional/programs/diets/details/download/page-program-reports';
import PageSendToParticipant from 'components/pages/professional/programs/diets/details/send-to-participant/page-send-to-participant';
import PageMakeCopyProgram from 'components/pages/professional/programs/shared/make-copy/page-make-copy-program';
import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';

import LayoutSetAbstract from 'components/ui/layout-set/abstract/abstract-layout-set-details';

export default {
  name: 'layout-set-diet-details',
  componentName: 'LayoutSetDietDetails',
  mixins: [LayoutSetAbstract],
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: PROGRAMS_KEYS.diet,
    },
  },
  components: {
    PageHelp,
    PageProgramReports,
    PageMakeCopyProgram,
    PageSendToParticipant,
    SidebarMenuDietExpanded,
    SidebarMenuDietCollapsed,
    SidebarMenuLevelZeroCollapsed,
  },
  data() {
    return {
      show: {
        pageHelp: false,
        pageProgramReports: false,
        pageMakeCopyProgram: false,
        pageSendProgramToParticipant: false,
      },
    };
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    initialDayID() {
      const day = isNil(this.dayID) ? first(this.ProgramDetails.data.ProgramDays) : find(this.ProgramDetails.data.ProgramDays, item => Number(item.id) === Number(this.dayID));
      return get(day, 'id', null);
    },
  },
  methods: {
    fetchDetails() {
      this.$store.dispatch('GetProgramDetails', { id: this.id, type: this.type });
    },
    clearDetails() {
      this.$store.dispatch('ClearProgramDetails', { id: this.id });
    },
  },
  created() {
    this.$on(EVENT.SHOW_PAGE_HELP, () => {
      console.log('SHOW_PAGE_HELP');
      this.show.pageHelp = true;
    });

    this.$on(EVENT.SHOW_PAGE_PROGRAM_REPORTS, () => {
      console.log('SHOW_PAGE_PROGRAM_REPORTS');
      this.show.pageProgramReports = true;
    });

    this.$on(EVENT.SHOW_PAGE_SEND_PROGRAM_TO_PARTICIPANT, () => {
      console.log('SHOW_PAGE_SEND_PROGRAM_TO_PARTICIPANT');
      this.show.pageSendProgramToParticipant = true;
    });

    this.$on(EVENT.SHOW_PAGE_MAKE_COPY_PROGRAM, () => {
      console.log('SHOW_PAGE_MAKE_COPY_PROGRAM');
      this.show.pageMakeCopyProgram = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/programs/layout-set-diet-details.vue